import Mun from "./Mun"

class SuperSix extends Mun {
}

export default SuperSix
